import React, { useState, useRef } from 'react';
import * as LucideIcons from 'lucide-react';

const AudioPlayer = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  return (
    <div className="flex items-center gap-2 bg-gray-800 p-2 rounded-full">
      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={() => setIsPlaying(false)}
      />
      <button onClick={togglePlayPause} className="text-white">
        {isPlaying ? <LucideIcons.Pause size={20} /> : <LucideIcons.Play size={20} />}
      </button>
      <div className="text-xs text-gray-300">
        {formatTime(currentTime)} / {formatTime(duration)}
      </div>
      <input
        type="range"
        min="0"
        max={duration}
        value={currentTime}
        onChange={(e) => (audioRef.current.currentTime = e.target.value)}
        className="w-full h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer"
      />
    </div>
  );
};

export default AudioPlayer;
